import tw, { styled } from 'twin.macro';

export const TabButtonContainer = styled.div<{ isActive: boolean }>`
  border-radius: 40px;
  ${tw`cursor-pointer p-1 flex flex-row items-center capitalize`};
  ${props => (props.isActive ? tw`bg-white` : tw`bg-transparent`)}
`;

export const TabButtonIcon = styled.div<{ isActive: boolean }>`
  ${tw`pe-1`};
  ${props => (props.isActive ? tw`text-dark-low` : tw`text-light-disabled`)}
`;

export const TabButtonText = styled.div<{ isActive: boolean }>`
  ${tw`font-semibold`};
  ${props => (props.isActive ? tw`text-dark-high` : tw`text-light-low`)}
`;
